module.exports = __webpack_public_path__ + "img/dec_icon.bbd67d79.svg";